<template>
  <!-- 模版类型1 -->
  <template v-if="componentInfo && componentInfo.footerStyle === 1">
    <div class="footer-wrapper">
      <div class="footer-style1">
        <div v-if="showContactAndLinks" class="footer-main w">
          <!-- 左侧：联系我们 -->
          <div class="contact-section">
            <div class="section-title">联系我们</div>
            <div class="contact-item">
              <img src="@/assets/icon_num.svg">
              <span>咨询热线：400-1187-985</span>
            </div>
            <div class="contact-item">
              <img src="@/assets/icon_email.svg">
              <span>邮箱：yixuejiaoyujituan@shanxiyixue.com</span>
            </div>
          </div>
          <!-- 中间：友情链接 -->
          <div class="link-section">
            <div class="section-title">友情链接</div>
            <div class="blogroll">
              <template v-for="item in componentInfo.customList">
                <span v-if="item.titleShow" :key="item.id" class="link_wrap">
                  <span v-if="!getLinkUrl(item.linkUrl)" class="link">{{ item.title }}</span>
                  <a v-else :href="item.linkUrl" class="link" target="_blank">
                    {{ item.title }}
                  </a>
                </span>
              </template>
            </div>
          </div>
          <!-- 右侧：二维码 -->
          <div v-if="showQr" class="qr-section">
            <div class="qr-item">
              <img src="@/assets/video_pr.svg" alt="易甄学官方视频号" />
              <div class="qr-text">易甄学官方视频号</div>
            </div>
            <div class="qr-item">
              <img src="@/assets/wx_qr.svg" alt="易甄学小程序" />
              <div class="qr-text">易甄学小程序</div>
            </div>
          </div>
        </div>
        <!-- 下部分版权 -->
        <div class="footer-copyright">
          <span class="mgr10">Copyright ©</span>{{ componentInfo.copyright }}
        </div>
      </div>
    </div>
    <!-- <div class="footer-wrapper">
      <div class="footer-style1">
        <div class="copyright">
          <span class="mgr10">Copyright ©</span>{{ componentInfo.copyright }}
        </div>
        <div class="blogroll">
          <template v-for="item in componentInfo.customList">
            <span v-if="item.titleShow" :key="item.id" class="link_wrap">
              <span v-if="!getLinkUrl(item.linkUrl)" class="link mgr10">{{
                item.title
              }}</span>
              <a v-else :href="item.linkUrl" class="link mgr10" target="_blank">
                {{ item.title }}
              </a>
            </span>
          </template>
        </div>
      </div>
    </div> -->
  </template>
  <!-- 模版类型2 -->
  <template v-if="componentInfo && componentInfo.footerStyle === 2">
    <div class="footer-wrapper">
      <div class="footer-style2">
        <ul v-if="componentInfo.navList.length" class="footer_nav">
          <li
            v-for="(item, index) in componentInfo.navList"
            :key="index"
            class="nav_item"
          >
            <custom-link
              :to="handleNavigate(item)"
              :target-type="item.targetType"
              :target-open-new-page="item.targetOpenNewPage"
              custom-class="nav_item"
            >
              <div class="nav_name">
                {{ item.navName }}
              </div>
              <div
                v-if="index !== componentInfo.navList.length - 1"
                class="border"
              />
            </custom-link>
          </li>
        </ul>
        <div class="copyright">
          <span class="mgr10">Copyright ©</span>{{ componentInfo.copyright }}
        </div>
        <div class="blogroll">
          <template v-for="item in componentInfo.customList">
            <span v-if="item.titleShow" :key="item.id" class="link_wrap">
              <span v-if="!getLinkUrl(item.linkUrl)" class="link mgr10">{{
                item.title
              }}</span>
              <a v-else :href="item.linkUrl" class="link mgr10" target="_blank">
                {{ item.title }}
              </a>
            </span>
          </template>
        </div>
      </div>
    </div>
  </template>
  <!-- 模版类型3 -->

  <template v-if="componentInfo && componentInfo.footerStyle === 3">
    <div class="footer-wrapper">
      <div class="footer-style3 w">
        <div class="footer-left">
          <div class="row">
            {{ componentInfo.contentOne }}
          </div>
          <div class="row">
            {{ componentInfo.contentTwo }}
          </div>
          <div class="row line" />
          <div class="row copyright">
            <span class="mgr10">Copyright ©</span>{{ componentInfo.copyright }}
          </div>
          <div class="row blogroll">
            <template v-for="item in componentInfo.customList">
              <span v-if="item.titleShow" :key="item.id" class="link_wrap">
                <span v-if="!getLinkUrl(item.linkUrl)" class="link mgr10">{{
                  item.title
                }}</span>
                <a
                  v-else
                  :href="item.linkUrl"
                  class="link mgr10"
                  target="_blank"
                >
                  {{ item.title }}
                </a>
              </span>
            </template>
          </div>
        </div>
        <div class="footer-right">
          <client-only>
            <el-popover
              v-if="componentInfo.showWechat"
              placement="top"
              trigger="hover"
            >
              <template #reference>
                <img
                  class="pointer mgr20"
                  src="@/assets/images/wechat.png"
                  alt=""
                />
                <!-- <i class="font32 iconfont icon-weixin"></i> -->
              </template>
              <img class="popover_img" :src="componentInfo.wechatUrl" alt="" />
            </el-popover>
          </client-only>
          <client-only>
            <el-popover
              v-if="componentInfo.showMiniApp"
              placement="top"
              trigger="hover"
            >
              <template #reference>
                <img
                  class="pointer mgr20"
                  src="@/assets/images/miniApp.png"
                  alt=""
                />
                <!-- <i class="font32 mgl20 iconfont icon-xiaochengxu"></i> -->
              </template>
              <img class="popover_img" :src="componentInfo.miniAppUrl" alt="" />
            </el-popover>
          </client-only>
          <a
            v-if="componentInfo.showWeibo"
            target="_blank"
            :href="componentInfo.weiboUrl"
          >
            <img class="pointer mgr20" src="@/assets/images/weibo.png" alt="" />
          </a>

          <!-- <i
            v-if="componentInfo.showWeibo"
            class="font32 mgl20 iconfont icon-weibo"
          ></i> -->
          <a
            v-if="componentInfo.showQq"
            target="_blank"
            :href="
              'https://wpa.qq.com/msgrd?y=3&uin=' +
              componentInfo.qqUrl +
              '&site=qq&menu=yes'
            "
          >
            <img class="pointer" src="@/assets/images/QQ.png" alt="" />
          </a>
          <!-- <i
            v-if="componentInfo.showQq"
            class="font32 mgl20 iconfont icon-QQ"
          ></i> -->
        </div>
      </div>
    </div>
  </template>
</template>
<script setup>
import { getFooter } from "@/api/layouts";
import { validateURL } from "@/utils/validate";
import { useLayoutStore } from "@/stores/layout";
import { showMainShopExtras } from "@/utils/mainShop";
const { setFooterType } = useLayoutStore();
const host = ref(null);

const getLinkUrl = (url) => {
  return validateURL(url) ? url : "";
};
const { data: componentInfo } = await useAsyncData("footer", async (ctx) => {
  // 服务端渲染时在这里获取域名
  if (process.server && ctx.ssrContext?.event?.req?.headers?.host) {
    host.value = ctx.ssrContext.event.req.headers.host.split(":")[0];
  }
  return getFooter();
});

const showQr = computed(() => showMainShopExtras(host.value));

/** 仅易甄学主站展示联系我们 / 友情链接 */
const showContactAndLinks = computed(() => showMainShopExtras(host.value));

onMounted(() => {
  host.value = window.location.hostname;
  if (componentInfo.value) {
    setFooterType(componentInfo.value.footerStyle);

    if (host.value === "xwyh.shanxiyixue.com") {
      componentInfo.value.copyright = componentInfo.value.copyright.replace(
        "易甄学 • ",
        ""
      );
    } else if (host.value === "xue.coeedu.cn") {
      componentInfo.value.copyright = "鄂ICP备19026305号-1";
    } else if (host.value === "guozijy.com" || host.value === "www.guozijy.com") {
      componentInfo.value.copyright = "滇ICP备2026009503号-1";
    } else if (host.value === "kecheng.wuyouyanxue.cn") {
      componentInfo.value.copyright = "浙ICP备2023011106号";
    }
    //   host.value == "xwyh.shanxiyixue.com"
    //     ? componentInfo.value.customList.filter(
    //         (item) => item.title != "易学教育网"
    //       )
    //     : componentInfo.value.customList;
    componentInfo.value.customList = [
      "xwyh.shanxiyixue.com",
      "xue.coeedu.cn",
      "guozijy.com",
      "www.guozijy.com",
      "kecheng.wuyouyanxue.cn",
    ].includes(host.value)
      ? componentInfo.value.customList.filter(
          (item) => item.title != "易学教育网"
        )
      : componentInfo.value.customList;
  }
});
</script>
<style lang="scss">
.footer-wrapper {
  width: 100%;
  background: #16223d;
  color: #becadb;
  line-height: 32px;
  .footer-style1 {
    .section-title {
      font-size: 15px;
      color: #E6E8E9;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .footer-main {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 20px;
      width: 1300px;
      margin: 0 auto;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    .contact-section {
      width: 360px;
      margin: 30px 20px 0 0;
      .contact-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #becadb;
        line-height: 2.2;
        margin-bottom: 0;
        img {
          width: 12px;
        }
      }
    }
    .link-section {
      flex: 1;
      margin: 30px 20px 0 20px;
      .blogroll {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0 10px;
        align-items: start;
      }
      .link_wrap {
        width: auto;
        margin-right: 0;
        line-height: 2.2;
      }
      .link {
        color: #becadb;
        font-size: 14px;
        text-decoration: none;
        &:hover {
          color: #ffffff;
        }
      }
    }
    .qr-section {
      width: 360px;
      margin: 20px 0 0 0;
      display: flex;
      gap: 60px;
      justify-content: flex-start;
      .qr-item {
        text-align: center;
        img {
          width: 110px;
          height: 110px;
          background: #ffffff;
          border-radius: 8px;
          display: block;
          margin-bottom: 8px;
        }
        .qr-text {
          font-size: 14px;
          color: #becadb;
        }
      }
    }
    /* 底部版权 */
    .footer-copyright {
      text-align: center;
      padding: 16px 0 20px;
      font-size: 12px;
      color: #9fa6af;
    }
  }
  // .footer-style1 {
  //   vertical-align: center;
  //   width: 100%;
  //   height: 150px;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;
  //   align-items: center;
  // }
  .footer-style2 {
    vertical-align: center;
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .footer_nav {
      display: flex;
      align-items: center;
    }
    .nav_item {
      display: flex;
      align-items: center;
      .nav_name {
        color: #becadb;
        white-space: nowrap;
      }
      .border {
        border: none;
        background: #becadb;
        display: inline-block;
        height: 10px;
        margin: 0 10px;
        width: 1px;
      }
    }
  }
  .footer-style3 {
    display: flex;
    justify-content: space-between;
    height: 260px;
    .footer-left {
      padding-top: 30px;
      height: 100%;
      .line {
        margin: 30px 0;
        width: 20px;
        height: 3px;
        background: #becadb;
      }
    }
    .footer-right {
      display: flex;
      align-items: center;
      height: 100%;
      .popover_img {
        width: 100px;
        height: 100px;
        object-fit: cover;
      }
    }
  }
}
.link {
  color: #becadb;
}
</style>
